import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const EMPTY = { name: "", email: "", password: "", phone: "" };

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const change = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("sending");
    try {
      await register(form);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message);
      setStatus("idle");
    }
  };

  return (
    <div className="wrap authwrap">
      <form className="formcard" onSubmit={submit} noValidate>
        <p className="eyebrow">Nuevo por aquí</p>
        <h1 style={{ fontSize: "1.8rem", margin: "8px 0 22px" }}>Crea tu cuenta</h1>

        {error && <div className="alert alert--error">{error}</div>}

        <label className="field">
          <span>Nombre</span>
          <input name="name" value={form.name} onChange={change} autoComplete="name" required />
        </label>

        <label className="field">
          <span>Email</span>
          <input type="email" name="email" value={form.email} onChange={change} autoComplete="email" required />
        </label>

        <label className="field">
          <span>Contraseña</span>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={change}
            autoComplete="new-password"
            minLength={6}
            required
          />
          <small style={{ color: "var(--stone)" }}>Mínimo 6 caracteres.</small>
        </label>

        <label className="field">
          <span>Teléfono (opcional)</span>
          <input name="phone" value={form.phone} onChange={change} autoComplete="tel" />
        </label>

        <button type="submit" className="btn btn--lg btn--block" style={{ marginTop: 8 }} disabled={status === "sending"}>
          {status === "sending" ? "Creando cuenta…" : "Crear cuenta"}
        </button>

        <p style={{ marginTop: 18, fontSize: "0.92rem", textAlign: "center" }}>
          ¿Ya tienes cuenta? <Link to="/login" className="linkish">Inicia sesión</Link>
        </p>
      </form>
    </div>
  );
}
